import { FLAGS, FLAGS_IDENTITY_LOADED, FLAGS_IDENTITY_LOADING } from '../constants/featureFlags';

export const setFlags = (features) => async (dispatch) => {
  dispatch({
    type: FLAGS,
    payload: features,
  });
};

export const setFlagsIdentityLoading = () => ({ type: FLAGS_IDENTITY_LOADING });
export const setFlagsIdentityLoaded = (userId) => ({ type: FLAGS_IDENTITY_LOADED, payload: userId });
